import { Flex, FlexProps, Icon, TextProps } from '@chakra-ui/react';
import { HighlightedTooltipText } from '@/components/global-search/text/HighlightedTooltipText';

export const IconText = ({
  icon,
  text,
  textProps,
  highlight,
  wrapperProps,
}: {
  icon: React.ElementType;
  text: string;
  textProps?: TextProps;
  highlight?: string;
  wrapperProps?: FlexProps;
}) => {
  if (!text) return null;

  return (
    <Flex alignItems="center" gap="6px" {...wrapperProps}>
      <Icon as={icon} color="secondary-500" width="16px" height="16px" />
      <HighlightedTooltipText
        color="secondary-700"
        {...textProps}
        variant="heading_4"
        text={text}
        highlight={highlight}
      />
    </Flex>
  );
};
